import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { DxButtonModule, DxDataGridModule } from 'devextreme-angular';
import { NotFoundComponent } from './shared/layoutComponents/not-found/not-found.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/autenticacion/' },
  {
    path: 'inicio', loadChildren: () =>
      import('./feature/inicio/inicio.module').then(mod => mod.InicioModule)
  },
  {
    path: 'monitoreo', loadChildren: () =>
      import('./feature/monitoreo/monitoreo.module').then(mod => mod.MonitoreoModule)
  },
  {
    path: 'autenticacion', loadChildren: () =>
      import('./feature/autenticacion/autenticacion.module').then(mod => mod.AutenticacionModule)
  },
  {
    path: 'general', loadChildren: () =>
      import('./feature/general/general.module').then(mod => mod.GeneralModule)
  },
  {
    path: 'reporte', loadChildren: () =>
      import('./feature/reportes/reportes.module').then(mod => mod.ReportesModule)
  },
  {
    path: 'consultar-registro-agencia', loadChildren: () =>
      import('./feature/registro-agencias/registro-agencias.module').then(mod => mod.RegistroAgenciasModule),
    data: { nombre: 'Registro Agencias' }
  },
  {
    path: 'rifas', loadChildren: () =>
      import('./feature/rifas/rifas.module').then(mod => mod.RifasModule),
    data: { nombre: 'rifas' }
  },
  {
    path: 'util', loadChildren: () =>
      import('./shared/shared.module').then(mod => mod.SharedModule),
    data: { nombre: 'util' }
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [
    DxDataGridModule,
    DxButtonModule,
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})


export class AppRoutingModule { }
